"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMealDeliveryCounts = exports.useSelections = exports.useMealDeliveryContext = exports.MealDeliveryProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var common_utils_1 = require("@fdha/common-utils");
// Helper function to calculate sum of selected quantities
var getQuantitySelected = function (items) {
    return items.reduce(function (total, item) { return total + (item.quantity || 0); }, 0);
};
// Helper function to process raw API response into simplified structure
var processMenuOptions = function (menuOptions) {
    // Use existing utility to group and deduplicate properly
    var grouped = (0, common_utils_1.groupMenuOptionsByMealOptionType)(menuOptions);
    if (!grouped) {
        return {
            entrees: [],
            snacksAndSides: [],
        };
    }
    // Flatten the grouped structure to get deduplicated arrays
    var entrees = (0, common_utils_1.flattenDishes)(grouped.entreeDishes);
    var snacksAndSides = (0, common_utils_1.flattenDishes)(grouped.snacks);
    return {
        entrees: entrees,
        snacksAndSides: snacksAndSides,
    };
};
var createMealDeliveryReducer = function (bridge) {
    return function (state, action) {
        switch (action.type) {
            case 'SET_LOADING':
                return __assign(__assign({}, state), { loading: action.payload });
            case 'SET_ERROR':
                return __assign(__assign({}, state), { error: action.payload, loading: false });
            case 'SET_SAVING':
                return __assign(__assign({}, state), { isSaving: action.payload });
            case 'SET_MENU_OPTIONS': {
                var menuOptions = action.payload;
                var _a = processMenuOptions(menuOptions), entrees = _a.entrees, snacksAndSides = _a.snacksAndSides;
                // Preserve existing quantities when processing new menu data
                var preserveQuantities = function (newItems, existingItems) {
                    return newItems.map(function (newItem) {
                        var existingItem = existingItems.find(function (existing) {
                            var _a;
                            var menuIdMatch = existing.menuOptionId === newItem.menuOptionId;
                            // For meal kits, also match variant ID
                            var variantIdMatch = newItem.mealOptionType === ((_a = bridge.MealOptionType) === null || _a === void 0 ? void 0 : _a.MealKit)
                                ? existing.mealkitVariantId === newItem.mealkitVariantId
                                : true;
                            return menuIdMatch && variantIdMatch;
                        });
                        return __assign(__assign({}, newItem), { quantity: existingItem
                                ? existingItem.quantity
                                : newItem.quantity || 0 });
                    });
                };
                var preservedEntrees = preserveQuantities(entrees, state.entrees);
                var preservedSnacksAndSides = preserveQuantities(snacksAndSides, state.snacksAndSides);
                // This represents the quantities user or admin actually selected
                var originalEntreesCount = getQuantitySelected(entrees);
                var originalSnacksCount = getQuantitySelected(snacksAndSides);
                // For admin platforms: use original API values so they see the plan limits
                // For patient/mobile platforms: use calculated max so patients can fulfill their actual delivery
                var finalAmountPerDay = bridge.isAdminPlatform
                    ? (menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions.amountPerDay) || 0
                    : Math.max((menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions.amountPerDay) || 0, originalEntreesCount);
                var finalSnackAmount = bridge.isAdminPlatform
                    ? (menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions.snackAmount) || 0
                    : Math.max((menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions.snackAmount) || 0, originalSnacksCount);
                return __assign(__assign({}, state), { amount: (menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions.amount) || 0, amountPerDay: finalAmountPerDay, snackAmount: finalSnackAmount, entrees: preservedEntrees, snacksAndSides: preservedSnacksAndSides, loading: false, 
                    // Only reset isDirty if this is the initial load (no existing items)
                    isDirty: state.entrees.length > 0 ? state.isDirty : false });
            }
            case 'UPDATE_SELECTION': {
                var _b = action.payload, isEntree = _b.isEntree, menuOptionId_1 = _b.menuOptionId, quantity = _b.quantity, mealkitVariantId_1 = _b.mealkitVariantId;
                var targetArray = isEntree ? state.entrees : state.snacksAndSides;
                // Find the item to update
                var itemIndex = targetArray.findIndex(function (item) {
                    var menuIdMatch = item.menuOptionId === menuOptionId_1;
                    // For meal kits, check if variant ID matches
                    var variantIdMatch = item.mealOptionType === bridge.MealOptionType.MealKit &&
                        mealkitVariantId_1
                        ? item.mealkitVariantId === mealkitVariantId_1
                        : true;
                    return menuIdMatch && variantIdMatch;
                });
                if (itemIndex === -1) {
                    return state;
                }
                // Update the quantity in the appropriate array
                var newTargetArray = __spreadArray([], targetArray, true);
                newTargetArray[itemIndex] = __assign(__assign({}, newTargetArray[itemIndex]), { quantity: quantity });
                return __assign(__assign({}, state), { entrees: isEntree ? newTargetArray : state.entrees, snacksAndSides: isEntree ? state.snacksAndSides : newTargetArray, isDirty: true });
            }
            case 'SET_CLEAN':
                return __assign(__assign({}, state), { isDirty: false });
            case 'SET_CLOSED_DELIVERY_LOADING':
                return __assign(__assign({}, state), { closedDeliveryLoading: action.payload });
            case 'SET_CLOSED_DELIVERY_ERROR':
                return __assign(__assign({}, state), { closedDeliveryError: action.payload, closedDeliveryLoading: false });
            case 'SET_CLOSED_DELIVERY_DATA':
                return __assign(__assign({}, state), { closedDeliveryData: action.payload, closedDeliveryLoading: false });
            case 'SET_DELIVERY_STATUS':
                return __assign(__assign({}, state), { deliveryId: action.payload.deliveryId, deliveryStatus: action.payload.deliveryStatus, isCanceled: action.payload.isCanceled });
            default:
                return state;
        }
    };
};
var MealDeliveryContext = (0, react_1.createContext)(null);
var MealDeliveryProvider = function (_a) {
    var children = _a.children, bridge = _a.bridge, patientId = _a.patientId, dietPlanDeliveryMenuId = _a.dietPlanDeliveryMenuId, foodProgramUserId = _a.foodProgramUserId, deliveryId = _a.deliveryId, deliveryStatus = _a.deliveryStatus, isCanceled = _a.isCanceled;
    var mealDeliveryReducer = (0, react_1.useMemo)(function () { return createMealDeliveryReducer(bridge); }, [bridge]);
    var _b = (0, react_1.useReducer)(mealDeliveryReducer, {
        amount: 0,
        amountPerDay: 0,
        snackAmount: 0,
        entrees: [],
        snacksAndSides: [],
        isDirty: false,
        loading: false,
        error: null,
        isSaving: false,
        isSubmitting: false,
        submissionError: null,
        // Use props for delivery status instead of context
        deliveryId: deliveryId || null,
        deliveryStatus: deliveryStatus || null,
        isCanceled: isCanceled || false,
        closedDeliveryData: null,
        closedDeliveryLoading: false,
        closedDeliveryError: null,
    }), state = _b[0], dispatch = _b[1];
    // Use platform-specific GraphQL hooks with props only
    var queryVariables = bridge.buildQueryVariables(patientId || null, dietPlanDeliveryMenuId || null);
    var shouldSkipQuery = !dietPlanDeliveryMenuId;
    var _c = bridge.useGetMenuOptionSelectionsQuery({
        variables: queryVariables,
        fetchPolicy: 'cache-and-network',
        skip: shouldSkipQuery,
    }), data = _c.data, loading = _c.loading, error = _c.error;
    var updatePatientMealSelection = bridge.useUpdatePatientMealSelectionV2Mutation()[0];
    // Handle closed delivery data fetching
    var closedDeliveryQueryVariables = deliveryId
        ? bridge.buildClosedDeliveryQueryVariables(deliveryId)
        : null;
    var shouldSkipClosedDeliveryQuery = !deliveryId ||
        !deliveryStatus ||
        deliveryStatus === bridge.DeliveryStatus.Open;
    var _d = bridge.useGetSelectedMenuOptionsV2Query({
        variables: closedDeliveryQueryVariables,
        fetchPolicy: 'cache-and-network',
        skip: shouldSkipClosedDeliveryQuery,
    }), closedDeliveryData = _d.data, closedDeliveryLoading = _d.loading, closedDeliveryError = _d.error;
    // Handle GraphQL data loading and initialization
    (0, react_1.useEffect)(function () {
        if (loading) {
            dispatch({ type: 'SET_LOADING', payload: true });
        }
        else if (error) {
            dispatch({ type: 'SET_ERROR', payload: error });
            bridge.showError('Error loading available meal options');
        }
        else if (data) {
            var menuOptionsData = bridge.extractMenuOptionsData(data);
            if (menuOptionsData) {
                dispatch({
                    type: 'SET_MENU_OPTIONS',
                    payload: menuOptionsData,
                });
            }
        }
    }, [data, loading, error, bridge]);
    // Handle closed delivery data loading
    (0, react_1.useEffect)(function () {
        if (closedDeliveryLoading) {
            dispatch({ type: 'SET_CLOSED_DELIVERY_LOADING', payload: true });
        }
        else if (closedDeliveryError) {
            dispatch({
                type: 'SET_CLOSED_DELIVERY_ERROR',
                payload: closedDeliveryError,
            });
            bridge.showError('Error loading closed delivery data');
        }
        else if (closedDeliveryData) {
            var extractedData = bridge.extractClosedDeliveryData(closedDeliveryData);
            if (extractedData) {
                dispatch({
                    type: 'SET_CLOSED_DELIVERY_DATA',
                    payload: extractedData,
                });
            }
        }
    }, [closedDeliveryData, closedDeliveryLoading, closedDeliveryError, bridge]);
    // Handle delivery status props changes
    (0, react_1.useEffect)(function () {
        dispatch({
            type: 'SET_DELIVERY_STATUS',
            payload: {
                deliveryId: deliveryId || null,
                deliveryStatus: deliveryStatus || null,
                isCanceled: isCanceled || false,
            },
        });
    }, [deliveryId, deliveryStatus, isCanceled]);
    var updateSelection = (0, react_1.useCallback)(function (params) {
        dispatch({
            type: 'UPDATE_SELECTION',
            payload: {
                isEntree: params.isEntree,
                menuOptionId: params.menuOptionId,
                quantity: params.quantity,
                mealkitVariantId: params.mealkitVariantId,
            },
        });
    }, []);
    var saveSelections = (0, react_1.useCallback)(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var finalFoodProgramUserId, finalDeliveryMenuId, payload, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    finalFoodProgramUserId = (params === null || params === void 0 ? void 0 : params.foodProgramUserId) || foodProgramUserId || patientId;
                    finalDeliveryMenuId = (params === null || params === void 0 ? void 0 : params.deliveryMenuId) || dietPlanDeliveryMenuId;
                    if (!finalFoodProgramUserId || !finalDeliveryMenuId) {
                        bridge.showError('Missing required context for saving selections');
                        return [2 /*return*/, false];
                    }
                    dispatch({ type: 'SET_SAVING', payload: true });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    payload = (0, common_utils_1.buildPatientMealSelectionInputPayloadFromFlat)(state.entrees, state.snacksAndSides, finalFoodProgramUserId, finalDeliveryMenuId);
                    return [4 /*yield*/, updatePatientMealSelection({
                            variables: { props: payload },
                        })];
                case 2:
                    _a.sent();
                    dispatch({ type: 'SET_CLEAN' });
                    bridge.showSuccess('Meal selections saved successfully');
                    return [2 /*return*/, true];
                case 3:
                    err_1 = _a.sent();
                    dispatch({ type: 'SET_ERROR', payload: err_1 });
                    bridge.showError('Failed to save meal selections');
                    return [2 /*return*/, false];
                case 4:
                    dispatch({ type: 'SET_SAVING', payload: false });
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        updatePatientMealSelection,
        bridge,
        foodProgramUserId,
        patientId,
        dietPlanDeliveryMenuId,
        state.entrees,
        state.snacksAndSides,
    ]);
    var actions = (0, react_1.useMemo)(function () { return ({
        updateSelection: updateSelection,
        saveSelections: saveSelections,
    }); }, [updateSelection, saveSelections]);
    var contextValue = (0, react_1.useMemo)(function () { return ({
        state: state,
        actions: actions,
        bridge: bridge,
    }); }, [state, actions, bridge]);
    return ((0, jsx_runtime_1.jsx)(MealDeliveryContext.Provider, { value: contextValue, children: children }));
};
exports.MealDeliveryProvider = MealDeliveryProvider;
var useMealDeliveryContext = function () {
    var context = (0, react_1.useContext)(MealDeliveryContext);
    if (!context) {
        throw new Error('useMealDeliveryContext must be used within a MealDeliveryProvider');
    }
    return context;
};
exports.useMealDeliveryContext = useMealDeliveryContext;
// useReviewDeliveryData is now exported from its own dedicated file ./useReviewDeliveryData.ts
// useChooseMealsData is now exported from its own dedicated file ./useChooseMealsData.ts
// Enhanced selector hooks from mobile implementation
var useSelections = function () {
    var state = (0, exports.useMealDeliveryContext)().state;
    return (0, react_1.useMemo)(function () { return ({
        entrees: state.entrees.filter(function (item) { return item.quantity > 0; }),
        snacksAndSides: state.snacksAndSides.filter(function (item) { return item.quantity > 0; }),
    }); }, [state.entrees, state.snacksAndSides]);
};
exports.useSelections = useSelections;
// Enhanced counts hook with comprehensive validation logic from mobile
var useMealDeliveryCounts = function () {
    var state = (0, exports.useMealDeliveryContext)().state;
    return (0, react_1.useMemo)(function () {
        // Current selected quantities (total from all items, including qty 0)
        var selectedEntreesCount = getQuantitySelected(state.entrees);
        var selectedSnacksAndSidesCount = getQuantitySelected(state.snacksAndSides);
        // Maximum allowed amounts (these are the "total" in x/y display)
        var maxEntrees = state.amountPerDay;
        var maxSnacksAndSides = state.snackAmount;
        // Validation states - check if we've met the requirements
        var isEntreesValid = selectedEntreesCount >= maxEntrees;
        var isSnacksValid = maxSnacksAndSides === 0 ||
            selectedSnacksAndSidesCount >= maxSnacksAndSides;
        var isValid = isEntreesValid && isSnacksValid;
        // Calculate remaining amounts needed (for "Add X more" messages)
        var remainingEntrees = Math.max(0, maxEntrees - selectedEntreesCount);
        var remainingSnacks = Math.max(0, maxSnacksAndSides - selectedSnacksAndSidesCount);
        return {
            // Current selected counts (the "x" in x/y)
            selectedEntreesCount: selectedEntreesCount,
            selectedSnacksAndSidesCount: selectedSnacksAndSidesCount,
            // Maximum allowed amounts (the "y" in x/y - these should never change)
            maxEntrees: maxEntrees,
            maxSnacksAndSides: maxSnacksAndSides,
            // Remaining amounts needed
            remainingEntrees: remainingEntrees,
            remainingSnacks: remainingSnacks,
            // Validation states
            isEntreesValid: isEntreesValid,
            isSnacksValid: isSnacksValid,
            isValid: isValid,
            // Convenience properties for display
            entreeDisplay: {
                selected: selectedEntreesCount,
                total: maxEntrees,
                required: maxEntrees, // Mobile expects "required" to be the total amount needed
                remaining: remainingEntrees,
                isValid: isEntreesValid,
            },
            snacksDisplay: {
                selected: selectedSnacksAndSidesCount,
                total: maxSnacksAndSides,
                required: maxSnacksAndSides, // Mobile expects "required" to be the total amount needed
                remaining: remainingSnacks,
                isValid: isSnacksValid,
            },
        };
    }, [
        state.entrees,
        state.snacksAndSides,
        state.amountPerDay,
        state.snackAmount,
    ]);
};
exports.useMealDeliveryCounts = useMealDeliveryCounts;
